import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createSetBusinessValueCommand } from '../../../api/commands/factory/createPrioCommands';
import { BusinessValue } from '../../../api/queries';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SetBusinessValue extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SetBusinessValue';

    public constructor(public cardId: string, public businessValue: BusinessValue) {
        super(SetBusinessValue.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetBusinessValue): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await createSetBusinessValueCommand(action),
    });

    return true;
};

const reducer = (state: StorymapState, action: SetBusinessValue): void => {
    const card = state.subtasks.find((x) => x.id === action.cardId);

    card.businessValue = action.businessValue;
    card.lastUpdatedAt = new Date();
};

//@ts-ignore
registerMiddleware(SetBusinessValue.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetBusinessValue.ACTION_TYPE, reducer);
